import { type RemoteApiSpec } from "../../../../gql-generated/types";
import { dateTimeFormat } from "../../../utils";

export const searchApis = (apis: readonly RemoteApiSpec[], text: string): RemoteApiSpec[] => {
    text = text.toLowerCase();

    return apis.filter((api: RemoteApiSpec) => {
        const { approvalState, updatedAt, name, id } = api;
        const updatedAtStr = dateTimeFormat.format(new Date(updatedAt)).replace(",", "").toLowerCase();
        const approvalStateStr = approvalState.replace("_", " ").toLowerCase();

        return (
            !!name.toLowerCase().includes(text) ||
            !!id.includes(text) ||
            updatedAtStr.includes(text) ||
            approvalStateStr.includes(text)
        );
    });
};
